import { render } from "./AlimentationCalculator.vue?vue&type=template&id=4febfc50&scoped=true"
import script from "./AlimentationCalculator.vue?vue&type=script&lang=js"
export * from "./AlimentationCalculator.vue?vue&type=script&lang=js"

import "./AlimentationCalculator.vue?vue&type=style&index=0&id=4febfc50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4febfc50"]])

export default __exports__